import React from 'react';
// @ts-ignore
import FileViewer from 'react-file-viewer';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router';
import {useNavigate} from 'react-router-dom';
import { LeftOutlined} from '@ant-design/icons';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import {Button} from 'antd';
import _ from 'lodash';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import labels from '../../config/labels.json';
import {ILabel} from '../../config/lebels-type';
import {fileExt} from '../../shared/helpers/fullUrl';

import cls from './Story.module.scss'

export const ViewerFile = () => {

    const navigate = useNavigate()
    const {state} = useLocation();
    const {t} = useTranslation()

    const label = _.filter(labels, (label: ILabel) => label.identifier === state.identifier)[0]?.label;
    const ext = fileExt(state.url)

    return (
        <Layout header={<Header title={t(label)}
                                left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                              icon={<LeftOutlined/>}/>}
                                // right={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                //               icon={<DownloadOutlined/>}/>}
        />}
        >
            <div className={cls.wrapper}>

                {ext === 'jpg' || ext === 'png' ?
                <DocViewer documents={[{uri: state.url}]} pluginRenderers={DocViewerRenderers} />
                    :
                <FileViewer
                    fileType={ext}
                    filePath={state.url}
                />
                }
            </div>
        </Layout>

    )
}